import { sortBy } from 'lodash-es';
import { MapActivity, MapMilestone, MapPhase } from '@/store';

export function calculateFinalMilestoneMaxDeadlinePosition(
  nextPhase: MapPhase,
  activities: MapActivity[],
  nextMilestone?: MapMilestone,
) {
  // next phase has no activities and intermediate milestones
  if (!activities.length && nextMilestone?.isFinal) {
    return nextPhase.end - 1;
  }

  // next phase has only intermediate milestones
  if (!activities.length && nextMilestone) {
    return nextMilestone.originalPosition - 1;
  }

  const lastActivityInPhase = sortBy(activities, 'originalPosition')[0];

  // next phases' first milestone comes before an activity
  if (
    nextMilestone &&
    nextMilestone.originalPosition < lastActivityInPhase.originalPosition
  ) {
    return nextMilestone.originalPosition - 1;
  }

  //  activity in next phase is before the first milestone
  return lastActivityInPhase.originalPosition - 1;
}
